import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { UiTagComponent } from '../../../shared/components/ui-tag/ui-tag.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import { TimelineHistoricoComponent, TimelineHistoricoItem } from '../../../shared/components/timeline-historico/timeline-historico.component';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';

import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import {
  StatusOrdemProducaoBadge,
  StatusOrdemProducaoDescricao,
  StatusOrdemProducaoEnum,
} from '../../../shared/enums/suprimentos/status-ordem-producao.enum';
import {
  StatusEtapaOrdemProducaoBadge,
  StatusEtapaOrdemProducaoDescricao,
  StatusEtapaOrdemProducaoEnum,
} from '../../../shared/enums/suprimentos/status-etapa-ordem-producao.enum';
import { OrigemOcorrenciaEnum } from '../../../shared/enums/suprimentos/origem-ocorrencia.enum';
import { TipoIntegracaoEnum, TipoIntegracaoIndicador } from '../../../shared/enums/suprimentos/tipo-integracao.enum';

import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { OrdemProducaoService } from '../../../shared/services/apis/suprimentos/ordem-producao.service';
import { OrdemProducaoOrquestradorService } from '../../../shared/services/apis/orquestrador-suprimentos/ordem-producao-orquestrador.service';
import { OrdemProducaoDetalheStruct } from '../../../shared/services/structs/suprimentos/ordem-producao-detalhe.struct';
import { OrdemProducaoEtapaStruct } from '../../../shared/services/structs/suprimentos/ordem-producao-etapa.struct';
import { OrdemProducaoOcorrenciaStruct } from '../../../shared/services/structs/suprimentos/ordem-producao-ocorrencia.struct';
import { CriarOrdemProducaoOcorrenciaRequest } from '../../../shared/services/requests/suprimentos/criar-ordem-producao-ocorrencia.request';
import { OrdemProducaoEstoqueExcluirRequest } from '../../../shared/services/requests/suprimentos/ordem-producao-estoque-excluir.request';

import { AjustarTemposEtapaDialogComponent, AjustarTemposEtapaDialogResult } from './dialogs/ajustar-tempos-etapa-dialog/ajustar-tempos-etapa-dialog.component';
import { OrdensRelacionadasDialogComponent } from '../ordem-producao-lista/dialogs/ordens-relacionadas-dialog/ordens-relacionadas-dialog.component';
import { LancarEstoqueOrdemProducaoDialogComponent } from './dialogs/lancar-estoque-ordem-producao-dialog/lancar-estoque-ordem-producao-dialog.component';
import { ExcluirEstoqueOrdemProducaoDialogComponent } from './dialogs/excluir-estoque-ordem-producao-dialog/excluir-estoque-ordem-producao-dialog.component';
import { ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent } from '../../../shared/components/impressao-necessidade-materiais-ordem-producao-dialog/impressao-necessidade-materiais-ordem-producao-dialog.component';
import { ImpressaoEstruturaProdutoOrdemProducaoDialogComponent } from '../../../shared/components/impressao-estrutura-produto-ordem-producao-dialog/impressao-estrutura-produto-ordem-producao-dialog.component';
import { LancarEstoqueOrdemProducaoItemRequest } from '../../../shared/services/requests/suprimentos/lancar-estoque-ordem-producao-item.request';
import { ResumoEstoqueEntradaOrdemProducaoStruct } from '../../../shared/services/structs/suprimentos/resumo-estoque-entrada-ordem-producao.struct';
import { ResumoEstoqueInsumoOrdemProducaoStruct } from '../../../shared/services/structs/suprimentos/resumo-estoque-insumo-ordem-producao.struct';

@Component({
  selector: 'app-ordem-producao-detalhe',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    UiTagComponent,
    LoadingBoxComponent,
    TimelineHistoricoComponent,
    AlertCardComponent,
    AbntPipe,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './ordem-producao-detalhe.component.html',
  styleUrl: './ordem-producao-detalhe.component.css',
})
export class OrdemProducaoDetalheComponent implements OnInit {
  public moduloEnum = ModuloEnum.Suprimentos;
  public funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_OrdemProducao;
  public permissaoEnum = PermissaoEnum;

  public statusOrdemProducaoEnum = StatusOrdemProducaoEnum;
  public statusEtapaOrdemProducaoEnum = StatusEtapaOrdemProducaoEnum;
  public statusEtapaOrdemProducaoDescricao = StatusEtapaOrdemProducaoDescricao;
  public statusEtapaOrdemProducaoBadge = StatusEtapaOrdemProducaoBadge;
  public statusOrdemProducaoDescricao = StatusOrdemProducaoDescricao;
  public statusOrdemProducaoBadge = StatusOrdemProducaoBadge;

  @ViewChild(TimelineHistoricoComponent) timeline?: TimelineHistoricoComponent;

  public idOrdemProducao!: number;
  public ordem: OrdemProducaoDetalheStruct | null = null;
  /** Ocorrências já mapeadas para a seção do histórico; montadas a cada carga, não a cada detecção de mudança. */
  public itensHistorico: TimelineHistoricoItem[] = [];

  public _isLoading = false;
  /** Skeleton só da primeira carga; depois de agir ou anotar, a lista troca no lugar e os filtros ficam. */
  public _isLoadingHistorico = true;
  public isRegistrandoAnotacao = false;
  public _isLoadingResumoEstoque = false;

  public resumoEntrada: ResumoEstoqueEntradaOrdemProducaoStruct | null = null;
  public resumoInsumos: ResumoEstoqueInsumoOrdemProducaoStruct[] = [];
  public baixaMateriaPrimaAberta = false;

  /** Ids de etapa com ação em andamento (spinner por linha) — mesmo padrão de produto-precos. */
  public etapaEmAcao = new Set<number>();

  public podeAlterar = false;
  /** Lançar estoque usa a permissão Inserir da OP. */
  public podeInserir = false;
  public podeExcluir = false;
  /** Permissão 189: só exclui o estoque da OP; lançar vale para quem pode inserir a ordem. */
  public podeExcluirEstoque = false;

  public colunasComposicao: string[] = ['nome', 'sku', 'quantidadeUnitaria', 'quantidadeTotal', 'saldo'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private alertService: AlertService,
    private authService: AuthService,
    private ordemProducaoService: OrdemProducaoService,
    private ordemProducaoOrquestradorService: OrdemProducaoOrquestradorService,
  ) {}

  ngOnInit(): void {
    this.idOrdemProducao = Number(this.route.snapshot.paramMap.get('idOrdemProducao'));

    const usuario = this.authService.getUserInfos();
    const permissoes: number[] = usuario?.listaPermissoes ?? [];
    this.podeAlterar = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Alterar);
    this.podeInserir = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Inserir);
    this.podeExcluir = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_Excluir);
    this.podeExcluirEstoque = permissoes.includes(this.permissaoEnum.Suprimentos_OrdemProducao_ExcluirEstoque);

    this.carregarDetalhe();
    this.carregarHistorico();
  }

  private carregarDetalhe(): void {
    this._isLoading = true;
    this.ordemProducaoOrquestradorService.getById(this.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoading = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        this.ordem = res.ordemProducao;

        if (this.isEstoqueLancado) {
          this.carregarResumoEstoque();
        } else {
          this.resumoEntrada = null;
          this.resumoInsumos = [];
        }
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  private carregarResumoEstoque(): void {
    this._isLoadingResumoEstoque = true;
    this.ordemProducaoOrquestradorService.getResumoEstoque(this.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoadingResumoEstoque = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.resumoEntrada = res.entrada;
        this.resumoInsumos = res.insumos ?? [];
      },
      error: (err) => {
        this._isLoadingResumoEstoque = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  private carregarHistorico(): void {
    this.ordemProducaoOrquestradorService.getHistorico(this.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoadingHistorico = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        this.itensHistorico = (res.listaOcorrencia ?? []).map((ocorrencia) => this.paraItemHistorico(ocorrencia));
      },
      error: (err) => {
        this._isLoadingHistorico = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  private recarregar(): void {
    this.carregarDetalhe();
    this.carregarHistorico();
  }

  /** Sem usuário, o autor é a origem; a origem só aparece como badge quando não é o próprio usuário. */
  private paraItemHistorico(ocorrencia: OrdemProducaoOcorrenciaStruct): TimelineHistoricoItem {
    return {
      icone: ocorrencia.nomeIconeTipoOcorrencia,
      titulo: ocorrencia.nomeTipoOcorrencia,
      descricao: ocorrencia.descricao,
      detalhe: ocorrencia.detalhes,
      justificativa: ocorrencia.justificativa,
      dados: ocorrencia.dados,
      quando: ocorrencia.dataOcorrencia,
      quemNome: ocorrencia.nomeUsuario || ocorrencia.nomeOrigemOcorrencia,
      nomeOrigem: ocorrencia.nomeOrigemOcorrencia,
      iconeOrigem: ocorrencia.nomeIconeOrigemOcorrencia,
      exibirOrigem: ocorrencia.idOrigemOcorrencia !== OrigemOcorrenciaEnum.Usuario,
      nomeStatusAnterior: ocorrencia.nomeStatusOrdemProducaoAnterior,
      classeStatusAnterior:
        ocorrencia.idStatusOrdemProducaoAnterior != null ? StatusOrdemProducaoBadge[ocorrencia.idStatusOrdemProducaoAnterior] : null,
      nomeStatusAtual: ocorrencia.nomeStatusOrdemProducaoAtual,
      classeStatusAtual:
        ocorrencia.idStatusOrdemProducaoAtual != null ? StatusOrdemProducaoBadge[ocorrencia.idStatusOrdemProducaoAtual] : null,
    };
  }

  /** Anotação do dia vai sem data, para o servidor gravar a hora do registro; retroativa leva o dia escolhido. */
  public registrarAnotacao(anotacao: { descricao: string; dataOcorrencia: Date }): void {
    const request = new CriarOrdemProducaoOcorrenciaRequest();
    request.descricao = anotacao.descricao;
    request.dataOcorrencia = anotacao.dataOcorrencia.toDateString() === new Date().toDateString() ? null : anotacao.dataOcorrencia;

    this.isRegistrandoAnotacao = true;
    this.ordemProducaoOrquestradorService.criarOcorrencia(this.idOrdemProducao, request).subscribe({
      next: (res) => {
        this.isRegistrandoAnotacao = false;
        if (res.isError) {
          this.alertService.show('Aviso', res.errorDescription, AlertType.warning);
          return;
        }
        this.timeline?.limparAnotacao();
        this.alertService.show('Sucesso', 'Anotação registrada.', AlertType.success);
        this.carregarHistorico();
      },
      error: () => {
        this.isRegistrandoAnotacao = false;
        this.alertService.show('Erro', 'Não foi possível registrar a anotação.', AlertType.error);
      },
    });
  }

  // ── Integração de estoque ────────────────────────────────────────────────

  public get isEstoqueLancado(): boolean {
    return this.ordem?.isEstoqueLancado ?? false;
  }

  public get podeLancarEstoque(): boolean {
    return !!this.ordem && this.podeInserir && !this.isEstoqueLancado;
  }

  /** Indicadores do cabeçalho: a letra E só com o estoque lançado. */
  public get integracoes(): { sigla: string; rotulo: string; cor: string }[] {
    const indicadores: { sigla: string; rotulo: string; cor: string }[] = [];
    if (this.isEstoqueLancado) {
      const estoque = TipoIntegracaoIndicador[TipoIntegracaoEnum.Estoque];
      indicadores.push({ sigla: estoque.sigla, rotulo: 'Estoque lançado', cor: estoque.cor });
    }
    return indicadores;
  }

  // ── Etapas ───────────────────────────────────────────────────────────────

  public get totalEtapas(): number {
    return this.ordem?.etapas.length ?? 0;
  }

  public get etapasConcluidas(): number {
    return this.ordem?.etapas.filter((e) => e.idStatusEtapaOrdemProducao === StatusEtapaOrdemProducaoEnum.Concluida).length ?? 0;
  }

  public get progressoEtapas(): number {
    return this.totalEtapas > 0 ? (this.etapasConcluidas / this.totalEtapas) * 100 : 0;
  }

  private etapaAnterior(etapa: OrdemProducaoEtapaStruct): OrdemProducaoEtapaStruct | null {
    const anteriores = (this.ordem?.etapas ?? [])
      .filter((e) => e.ordem < etapa.ordem)
      .sort((a, b) => b.ordem - a.ordem);
    return anteriores[0] ?? null;
  }

  private get ordemNaoCancelada(): boolean {
    return this.ordem?.idStatusOrdemProducao !== StatusOrdemProducaoEnum.Cancelada;
  }

  /** Estoque lançado trava a OP por completo, como na API: sem editar, sem iniciar, concluir ou ajustar
   * tempos de etapa e sem cancelar ou voltar status. As ações de etapa e de status aparecem desabilitadas,
   * com o motivo no tooltip; para mexer, o usuário exclui o estoque antes. */
  public get isTravadaPorEstoque(): boolean {
    return this.isEstoqueLancado;
  }

  /** Com estoque lançado, a OP só avança de status: cancelar e voltar status exigem excluir o estoque antes. */
  public motivoStatusBloqueado(idStatusOrdemProducao: StatusOrdemProducaoEnum): string | null {
    if (!this.ordem || !this.isTravadaPorEstoque || idStatusOrdemProducao === this.ordem.idStatusOrdemProducao) return null;
    if (idStatusOrdemProducao === StatusOrdemProducaoEnum.Cancelada) return 'Exclua o estoque para cancelar';
    if (idStatusOrdemProducao < this.ordem.idStatusOrdemProducao) return 'Exclua o estoque para voltar o status';
    return null;
  }

  /** Bloqueio sequencial (seção 8.5 da US): só inicia se a anterior já concluiu. Com estoque lançado o
   * botão aparece desabilitado (isTravadaPorEstoque). */
  public podeIniciar(etapa: OrdemProducaoEtapaStruct): boolean {
    if (!this.podeAlterar || !this.ordemNaoCancelada) return false;
    if (etapa.idStatusEtapaOrdemProducao !== StatusEtapaOrdemProducaoEnum.Pendente) return false;

    const anterior = this.etapaAnterior(etapa);
    return !anterior || anterior.idStatusEtapaOrdemProducao === StatusEtapaOrdemProducaoEnum.Concluida;
  }

  /** Etapa pendente cuja anterior ainda não concluiu — mostra o ícone de cadeado. */
  public etapaBloqueada(etapa: OrdemProducaoEtapaStruct): boolean {
    return etapa.idStatusEtapaOrdemProducao === StatusEtapaOrdemProducaoEnum.Pendente && !this.podeIniciar(etapa);
  }

  public podeConcluir(etapa: OrdemProducaoEtapaStruct): boolean {
    return this.podeAlterar && this.ordemNaoCancelada
      && etapa.idStatusEtapaOrdemProducao === StatusEtapaOrdemProducaoEnum.EmAndamento;
  }

  public podeAjustarTempos(): boolean {
    return this.podeAlterar && this.ordemNaoCancelada;
  }

  /** "25min" / "1h 30min" — só quando início e fim estão preenchidos. */
  public duracaoEtapa(etapa: OrdemProducaoEtapaStruct): string | null {
    if (!etapa.datetimeInicio || !etapa.datetimeFim) return null;

    const minutosTotais = Math.round(
      (new Date(etapa.datetimeFim).getTime() - new Date(etapa.datetimeInicio).getTime()) / 60000,
    );
    if (minutosTotais < 0) return null;

    const horas = Math.floor(minutosTotais / 60);
    const minutos = minutosTotais % 60;
    if (horas === 0) return `${minutos}min`;
    if (minutos === 0) return `${horas}h`;
    return `${horas}h ${minutos}min`;
  }

  public iniciarEtapa(etapa: OrdemProducaoEtapaStruct): void {
    this.etapaEmAcao.add(etapa.idOrdemProducaoEtapa);
    this.ordemProducaoService.iniciarEtapa(this.idOrdemProducao, etapa.idOrdemProducaoEtapa).subscribe({
      next: (res) => {
        this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.recarregar();
      },
      error: (err) => {
        this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public concluirEtapa(etapa: OrdemProducaoEtapaStruct): void {
    this.etapaEmAcao.add(etapa.idOrdemProducaoEtapa);
    this.ordemProducaoService.concluirEtapa(this.idOrdemProducao, etapa.idOrdemProducaoEtapa).subscribe({
      next: (res) => {
        this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.recarregar();
      },
      error: (err) => {
        this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public abrirAjustarTempos(etapa: OrdemProducaoEtapaStruct): void {
    const dialogRef = this.dialog.open(AjustarTemposEtapaDialogComponent, {
      maxWidth: '480px',
      width: '95vw',
      data: {
        descricaoEtapa: etapa.descricao,
        datetimeInicio: etapa.datetimeInicio,
        datetimeFim: etapa.datetimeFim,
      },
    });

    dialogRef.afterClosed().subscribe((result: AjustarTemposEtapaDialogResult | undefined) => {
      if (!result) return;

      this.etapaEmAcao.add(etapa.idOrdemProducaoEtapa);
      this.ordemProducaoService
        .ajustarTemposEtapa(this.idOrdemProducao, etapa.idOrdemProducaoEtapa, result)
        .subscribe({
          next: (res) => {
            this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
            if (res.isError) {
              this.alertService.show('Erro', res.errorDescription, AlertType.error);
              return;
            }
            this.recarregar();
          },
          error: (err) => {
            this.etapaEmAcao.delete(etapa.idOrdemProducaoEtapa);
            this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
          },
        });
    });
  }

  // ── Ações do menu ──────────────────────────────────────────────────────

  public alterarStatus(idStatusOrdemProducao: StatusOrdemProducaoEnum): void {
    if (!this.ordem || this.ordem.idStatusOrdemProducao === idStatusOrdemProducao) return;
    if (this.motivoStatusBloqueado(idStatusOrdemProducao)) return;

    this._isLoading = true;
    this.ordemProducaoService.alterarStatus(this.idOrdemProducao, { idStatusOrdemProducao }).subscribe({
      next: (res) => {
        this._isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', 'Status alterado.', AlertType.success);
        this.recarregar();
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public editar(): void {
    this.router.navigate(['/suprimentos/ordem-producao', this.idOrdemProducao, 'editar']);
  }

  public clonar(): void {
    this.router.navigate(['/suprimentos/ordem-producao/cadastrar'], {
      state: { clonarDeIdOrdemProducao: this.idOrdemProducao },
    });
  }

  public gerarOrdensRelacionadas(): void {
    if (!this.ordem) return;

    this._isLoading = true;
    this.ordemProducaoOrquestradorService.gerarOrdensRelacionadas(this.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoading = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        this.recarregar();
        if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);

        // O diálogo aparece mesmo quando nada foi gerado (seção 6.3 da US).
        this.dialog.open(OrdensRelacionadasDialogComponent, {
          maxWidth: '620px',
          width: '95vw',
          data: {
            numeroOrigem: res.numeroOrdemProducaoOrigem,
            ordensGeradas: res.ordensGeradas ?? [],
            algumFabricadoEncontrado: res.algumFabricadoEncontrado,
          },
        });
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  public abrirLancarEstoque(): void {
    if (!this.ordem) return;

    const dialogRef = this.dialog.open(LancarEstoqueOrdemProducaoDialogComponent, {
      maxWidth: '760px',
      width: '95vw',
      data: { ordem: this.ordem },
    });

    dialogRef.afterClosed().subscribe((request: LancarEstoqueOrdemProducaoItemRequest | undefined) => {
      if (!request) return;

      this._isLoading = true;
      this.ordemProducaoOrquestradorService.lancarEstoque({ ordens: [request] }).subscribe({
        next: (res) => {
          this._isLoading = false;
          if (res.isError) {
            this.alertService.show('Erro', res.errorDescription, AlertType.error);
            this.recarregar();
            return;
          }
          this.alertService.show('Sucesso', 'Estoque lançado.', AlertType.success);
          if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
          this.recarregar();
        },
        error: (err) => {
          this._isLoading = false;
          this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
          this.recarregar();
        },
      });
    });
  }

  public abrirExcluirEstoque(): void {
    if (!this.ordem) return;

    const dialogRef = this.dialog.open(ExcluirEstoqueOrdemProducaoDialogComponent, {
      maxWidth: '520px',
      width: '95vw',
      disableClose: true,
      data: { idOrdemProducao: this.ordem.idOrdemProducao, numero: this.ordem.numero, nomeProduto: this.ordem.nomeProduto },
    });

    dialogRef.afterClosed().subscribe((justificativa: string | undefined) => {
      if (!justificativa) return;
      this.executarExclusaoEstoque(justificativa);
    });
  }

  private executarExclusaoEstoque(justificativa: string): void {
    const request = new OrdemProducaoEstoqueExcluirRequest();
    request.justificativa = justificativa;

    this._isLoading = true;
    this.ordemProducaoOrquestradorService.excluirEstoque(this.idOrdemProducao, request).subscribe({
      next: (res) => {
        this._isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.recarregar();
          return;
        }
        this.alertService.show('Sucesso', 'Estoque excluído.', AlertType.success);
        if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
        this.recarregar();
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
        this.recarregar();
      },
    });
  }

  /** Impressão "Necessidade de materiais" (seção 7.1) — só desta OP, já carregada. */
  public imprimirDetalhe(): void {
    if (!this.ordem) return;

    this.dialog.open(ImpressaoNecessidadeMateriaisOrdemProducaoDialogComponent, {
      maxWidth: '900px',
      width: '95vw',
      data: { ordens: [this.ordem] },
    });
  }

  /** Impressão "Estrutura do Produto" (seção 7.2) — explosão recursiva multinível. */
  public imprimirEstrutura(): void {
    if (!this.ordem) return;

    this.dialog.open(ImpressaoEstruturaProdutoOrdemProducaoDialogComponent, {
      maxWidth: '900px',
      width: '95vw',
      data: { idOrdemProducao: this.ordem.idOrdemProducao },
    });
  }

  /**
   * Seção 3.8 do handoff: OP com estoque lançado NUNCA é excluída sem excluir o estoque antes, não é
   * opcional. Um único diálogo de confirmação, sem checkbox: se a OP tem estoque lançado, o texto
   * já avisa que o estoque é excluído junto ao confirmar e pede a justificativa. O atalho exige as
   * duas permissões: excluir a ordem (item do menu) e excluir o estoque.
   */
  public excluir(): void {
    if (!this.ordem) return;

    const temEstoqueLancado = this.isEstoqueLancado;
    if (temEstoqueLancado && !this.podeExcluirEstoque) {
      this.alertService.show('Atenção', 'Exclua o estoque antes de excluir esta ordem.', AlertType.warning);
      return;
    }

    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Excluir ordem de produção',
        innerHtml: temEstoqueLancado
          ? `<p>A OP ${this.ordem.numero} será excluída. O histórico da ordem é preservado.</p>
             <p>Esta ordem possui <strong>estoque lançado</strong>. Ao confirmar, o estoque será excluído antes da ordem.</p>`
          : `<p>A OP ${this.ordem.numero} será excluída. O histórico da ordem é preservado.</p>`,
        showTextarea: temEstoqueLancado,
        textareaLabel: 'Justificativa da exclusão',
        textareaRequired: true,
        textareaMinLength: 10,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result?.confirm) return;

      if (temEstoqueLancado) {
        this.excluirEstoqueEExcluir(result.textareaValue.trim());
      } else {
        this.confirmarExclusao();
      }
    });
  }

  private confirmarExclusao(): void {
    this._isLoading = true;
    this.ordemProducaoService.excluir(this.idOrdemProducao).subscribe({
      next: (res) => {
        this._isLoading = false;

        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }

        // A API não exclui OP com estoque lançado: devolve a flag, sem erro (ex.: a exclusão do estoque não chegou a ser registrada).
        if (res.requerExclusaoEstoque) {
          this.alertService.show('Atenção', 'Exclua o estoque antes de excluir.', AlertType.warning);
          this.recarregar();
          return;
        }

        this.alertService.show('Sucesso', 'Ordem de produção excluída.', AlertType.success);
        this.voltar();
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
      },
    });
  }

  private excluirEstoqueEExcluir(justificativa: string): void {
    const request = new OrdemProducaoEstoqueExcluirRequest();
    request.justificativa = justificativa;

    this._isLoading = true;
    this.ordemProducaoOrquestradorService.excluirEstoque(this.idOrdemProducao, request).subscribe({
      next: (res) => {
        if (res.isError) {
          this._isLoading = false;
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.recarregar();
          return;
        }
        if (res.avisoDescricao) this.alertService.show('Atenção', res.avisoDescricao, AlertType.warning);
        this.confirmarExclusao();
      },
      error: (err) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', err.message ?? err, AlertType.error);
        this.recarregar();
      },
    });
  }

  public voltar(): void {
    this.router.navigate(['/suprimentos/ordem-producao']);
  }
}
